import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader } from '@coreui/react'
import SuccessTick from '../../../assets/success-tick.svg'
import SyncError from '../../../assets/SyncError.svg'

const SyncModal = ({ type, title = '', description = '', confirmButtonText = '', onConfirm }) => {
  return (
    <CModal visible={true} size="lg" alignment="center">
      <CModalHeader className="border-0"></CModalHeader>
      <CModalBody className="border-0 d-flex flex-column align-items-center justify-content-center text-center px-5 py-4">
        {type === 'success' ? <img src={SuccessTick} /> : <img src={SyncError} />}
        <p style={{ fontSize: '25px', color: 'black', fontWeight: '600' }} className="mt-4">
          {title}
        </p>
        <p style={{ fontSize: '14px', color: '#929292' }} className="px-5">
          {description}
        </p>
        <div className="border-0 d-flex justify-center align-items-center mt-4">
          <CButton
            className="text-white px-4"
            style={{ fontSize: '0.9vw', background: '#20211c', borderColor: 'black' }}
            onClick={onConfirm}
          >
            {confirmButtonText}
          </CButton>
        </div>
      </CModalBody>
    </CModal>
  )
}

export default SyncModal
